import * as React from 'react';
import Stack from '@mui/material/Stack';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import CustomDatePicker from './CustomDatePicker';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from '../shared-theme/ColorModeIconDropdown';

import Search from './Search';
import { LocationOnOutlined, WarehouseOutlined } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import SubscriptionStatus from './SubscriptionStatus';
import { useLocation } from 'react-router-dom';

export default function Header({parent, child, onStartTour}) {
  const [clicked, setClicked] = React.useState(false);
  const location = useLocation();
  
  const handleClick = () => {
    setClicked(!clicked);
    
    if (!clicked && onStartTour) {
      // Determine tour type based on current screen
      const pathname = location.pathname;
      let tourType = 'dashboard'; // default
      
      if (pathname.includes('/productos_financieros/crear')) {
        tourType = 'crear-producto-financiero';
      } else if (pathname.includes('/productos_financieros')) {
        tourType = 'productos-financieros';
      } else if (pathname.includes('/prestamos')) {
        tourType = 'prestamos';
      } else if (pathname.includes('/centro_cobros')) {
        tourType = 'centro-cobros';
      } else if (pathname.includes('/gestion_comercial')) {
        tourType = 'gestion-comercial';
      } else if (pathname.includes('/logistica/productos')) {
        tourType = 'productos';
      } else if (pathname.includes('/logistica')) {
        tourType = 'logistica';
      } else if (pathname.includes('/configuracion')) {
        tourType = 'configuracion';
      } else if (pathname.includes('/dashboard')) {
        tourType = 'dashboard';
      }
      
      onStartTour(tourType);
    }
  };
  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <NavbarBreadcrumbs parent={parent} child={child}/>
      <Stack direction="row" sx={{ gap: 1 }}>
        <Stack direction="row" alignItems="center" spacing={5} mx={2} my={2}>
              <Stack direction="row" alignItems="center" spacing={1}>
                  <LocationOnOutlined sx={{marginLeft:10}} color="primary"/>
                  <Typography >Sucursal • {localStorage.getItem('nombre_sucursal')}</Typography>
              </Stack>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
              <Button
                style={{marginRight: 20}}
                variant="outlined"
                sx={{
                  fontWeight: "bold",
                  color: "primary.light",
                  borderColor: "primary.light",
                }}
                onClick={handleClick}
              >
                {"Visita Guiada"}
              </Button>
        </Stack>


      </Stack>
    </Stack>
  );
}
